import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Columns, LinkSidebarItem } from 'labguard-cdk'
import { AlarmWinkingChip } from 'src/components/common'
import { groupHasNoAlarm, getGroupColor } from 'src/services/group'
import styles from './GroupSidebarItem.scss'

/**
 * Sidebar item representing a channel group
 */
const GroupSidebarItem = ({ group }) => (
  <LinkSidebarItem tooltip={group.name} className={styles.link} to={`/groups/${group.id}`}>
    <Columns className={styles.group} align="center" gap="1rem" layout="auto 1">
      <AlarmWinkingChip
        colors={getGroupColor(group)}
        winkingAlarm={group.winkingAlarm}
        nbAlarms={group.nbChannelsWithAlarm}
        textClassName={classnames({ [styles.noAlarm]: groupHasNoAlarm(group) })}
      />
      <div className={styles.name}>{group.name}</div>
    </Columns>
  </LinkSidebarItem>
)

GroupSidebarItem.defaultProps = {}

GroupSidebarItem.propTypes = {
  group: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    nbChannelsWithAlarm: PropTypes.number,
    color: PropTypes.string,
    winkingAlarm: PropTypes.object,
  }),
}

export default GroupSidebarItem
